import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { isFutureDate, isOver90Days } from "../../../utils/utils";
import { MIN_INVOICE_THRESHOLD } from "../../../utils/constants/appConstants";

const CheckboxSelect = (props) => {
  const {
    invoiceData,
    selectedRows,
    setSelectedRows,
    isHeader = false,
    currentPageData = [],
    isUnderThreshold = false
  } = props;

  const checkboxRef = useRef();

  const isSelected = (rowId) => {
    return selectedRows.some((row) => row.id === rowId);
  };

  const isRowDisabled = (row) => {
    const isOver90 = isOver90Days({
      dueDate: row?.dueDate,
      invoiceDate: row?.invoiceDate
    });
    const isUnderThreshold =
      parseFloat(row.totalAmount) <= MIN_INVOICE_THRESHOLD;

    return isFutureDate(row?.invoiceDate) || isOver90 || isUnderThreshold;
  };
  const selectableRows = currentPageData.filter((row) => !isRowDisabled(row));

  const isAllSelected =
    selectableRows.length > 0 &&
    selectableRows.every((row) => selectedRows.some((r) => r.id === row.id));

  const isIndeterminate =
    selectableRows.length > 0 &&
    selectableRows.some((row) => selectedRows.some((r) => r.id === row.id)) &&
    !isAllSelected;

  useEffect(() => {
    if (isHeader && checkboxRef.current) {
      checkboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate, isHeader]);

  const handleCheckedInvoice = (invoice, isChecked) => {
    if (isRowDisabled(invoice)) return;
    setSelectedRows((prev) => {
      const exists = prev.some((row) => row.id === invoice.id);

      if (isChecked) {
        if (exists) {
          return prev.map((row) =>
            row.id === invoice.id ? { ...row, isChecked } : row
          );
        } else {
          return [...prev, { ...invoice, isChecked }];
        }
      } else {
        return prev.filter((row) => row.id !== invoice.id);
      }
    });
  };

  // Header select-all logic
  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedRows((prev) => {
        const existingIds = new Set(prev.map((item) => item.id));

        const newRows = currentPageData
          .filter((row) => !isRowDisabled(row))
          .filter((row) => !existingIds.has(row.id))
          .map((row) => ({ ...row, isChecked: true }));

        return [...prev, ...newRows];
      });
    } else {
      setSelectedRows((prev) =>
        prev.filter((item) => {
          const row = currentPageData.find((r) => r.id === item.id);
          if (!row) return true;
          if (isRowDisabled(row)) return true;
          return false;
        })
      );
    }
  };

  const isOver90 = isOver90Days({
    dueDate: invoiceData?.dueDate,
    invoiceDate: invoiceData?.invoiceDate
  });

  const isDisabled =
    isFutureDate(invoiceData?.invoiceDate) || isOver90 || isUnderThreshold;

  return (
    <input
      ref={checkboxRef}
      type="checkbox"
      disabled={isDisabled}
      checked={isHeader ? isAllSelected : isSelected(invoiceData.id)}
      onChange={(e) =>
        isHeader
          ? handleSelectAll(e.target.checked)
          : handleCheckedInvoice(invoiceData, e.target.checked)
      }
    />
  );
};

CheckboxSelect.propTypes = {
  invoiceData: PropTypes.any,
  selectedRows: PropTypes.array.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  isHeader: PropTypes.bool,
  currentPageData: PropTypes.array,
  isUnderThreshold: PropTypes.bool
};

export default CheckboxSelect;
